export { default } from './BatchActionsList';



// WEBPACK FOOTER //
// ./app/components/shared/BatchActions/BatchActionsList/index.js